<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageUrl]="'/settings'"
        [previousPageTitle]="'ADMINISTRATION.PAGE_TITLE' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.TITLE' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <email-labeling-config-list
      [namespace]="namespace()"
      [userId]="userId()"
      [reloadTrigger]="reloadTrigger()"
      (addNew)="onAddNew()"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"
    >
    </email-labeling-config-list>
  </glxy-page-wrapper>
</glxy-page>
